<template>
    <main id="yagish_about">
        <section class="hero_block">
            <h2 class="h2_other renew2_wrapper">유용한 정보</h2>
        </section>

        <section id="article" class="renew2_wrapper article">
            <div data-v-0c76a9cf class="wrapper article_container">
                <ul class="article_linklist">
                    <li class="article_item">
                        <a href="/kr/resume/article/guide01" class="article_link">이력서 작성 완벽 가이드｜양식, 예문, 꿀팁까지 총정리</a>
                    </li>
                    <li class="article_item">
                        <a href="/kr/resume/article/guide02" class="article_link">이력서 학력 기재법 완벽 정리｜작성 순서, 주의사항, 예시까지</a>
                    </li>
                    <li class="article_item">
                        <a href="/kr/resume/article/guide03" class="article_link">이력서 경력사항 작성법 완전 정리｜경력 기술서 예시 & 직무별
                            팁</a>
                    </li>
                    <li class="article_item">
                        <a href="/kr/resume/article/guide04" class="article_link">이력서 지원동기 예시 & 꿀팁 ! 취업 성공 첫걸음</a>
                    </li>
                    <li class="article_item">
                        <a href="/kr/resume/article/guide05" class="article_link">자기 PR 이렇게 쓰면 합격률 UP! 실전 팁 & 예시</a>
                    </li>
                    <li class="article_item">
                        <a href="/kr/resume/article/guide06" class="article_link">이력서 합격 공식! 바로 적용할 수 있는 실전 팁</a>
                    </li>
                </ul>
            </div>
        </section>
    </main>
</template>

<style lang="css" src="@/assets/css/renew_info.css"></style>
<style lang="scss" src="@/assets/scss/article/article.scss"></style>

<style lang="css" scoped>
.article {
    /*background: #FFFFE8;*/
    padding: 50px 0;
}

.article_h3 {
    text-align: center;
    font-size: 1.4rem;
    margin-bottom: 25px;
}

.article_item {
    border-bottom: 1px solid #eeeeee;
    width: 100%;
}

.article_item:last-child {
    border-bottom: 0;
}

.article_link {
    display: block;
    padding: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.articlelist {
    display: block;
    text-align: right;
}
</style>
<script>
export default {
    created: function () {
    }
}
</script>
